var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9480_3402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5V45.5C21 51.303 16.303 56 10.5 56C4.697 56 0 51.303 0 45.5V10.5C0 4.697 4.697 0 10.5 0C16.303 0 21 4.697 21 10.5ZM56 10.5V45.5C56 51.303 51.303 56 45.5 56C39.697 56 35 51.303 35 45.5V10.5C35 4.697 39.697 0 45.5 0C51.303 0 56 4.697 56 10.5Z",
    fill: "#8F8E93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9480_3402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyPause);
export default __webpack_public_path__ + "static/media/grey-pause.d3f82314c630a4aa938cfc4e833c35b2.svg";
export { ForwardRef as ReactComponent };